import { PlusCircleSVG } from 'common/assets';
import { Button } from 'components/elements/buttons';
import { useFormState } from 'components/elements/form';
import { SeparatorHorizontal, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import GuestCard from './guest-card';
import { ActivitySaleFormType } from '../form-type';
import { addNewActivitySaleItem } from '../hooks/use-get-default-values';

export default function ActivitySection() {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const { control } = useFormContext<ActivitySaleFormType>();
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'activitySales',
    keyName: 'customId',
  });

  const onAddActivity = React.useCallback(() => {
    append(addNewActivitySaleItem());
  }, [append]);

  const onRemoveActivity = React.useCallback(
    (index) => remove(index),
    [remove],
  );

  return (
    <div>
      {fields.map((field, index) => (
        <React.Fragment key={field.customId}>
          <GuestCard
            parentIndex={index}
            onRemove={() => onRemoveActivity(index)}
            fieldLength={fields.length}
          />
          <SeparatorVertical $margin={36} />
        </React.Fragment>
      ))}

      {editable && (
        <>
          <SeparatorHorizontal $margin={16} />
          <Button
            startEnhancer={(color, size) => (
              <PlusCircleSVG color={color} size={size} />
            )}
            buttonType="secondary"
            onClick={onAddActivity}
          >
            {t('common:add')}
          </Button>
        </>
      )}
    </div>
  );
}
